import React from 'react';
const Manager = (props) => {
    return (
        <h5>Manager</h5>
    )
}
export default Manager;